export const ngonQuickLinkContext = 'ngonQuickLink';

export enum ThemeCollectionTypeName {
  Store = 'STORE',
  Product = 'PRODUCT',
}
